import React from "react";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { IoWarningOutline } from "react-icons/io5";
import useProcessToday from "../../hooks/useProcessToday";
import { useTranslation } from "react-i18next";

export default function ProcessedToday() {
  const { t } = useTranslation();
  const { counter_success, counter_pending_review } = useProcessToday();

  return (
    <>
      <div className="rounded-xl bg-gradient-to-r from-vistactagreenlight to-vistactagreen ml-28 p-4 py-3 text-white relative truncate font-bold">
        <IoMdCheckmarkCircleOutline className="absolute -bottom-3 -right-2 fill-white text-6xl opacity-50" />
        <p className="text-xs">{t("orders_validated_today")}</p>
        <p className="text-3xl font-bold">{counter_success}</p>
      </div>
      <div className="rounded-xl bg-gradient-to-r from-vistactaorangelight to-vistactaorange ml-5 p-4 py-3 text-white relative truncate font-bold">
        <IoWarningOutline className="absolute -bottom-3 -right-2 fill-white text-6xl opacity-50" />
        <p className="text-xs">{t("orders_to_process")}</p>
        <p className="text-3xl font-bold">{counter_pending_review}</p>
      </div>
    </>
  );
}